// src/components/KeyMetricsSection.js
import React from 'react';
import MetricCard from './MetricCard';

function KeyMetricsSection({ metrics }) {
    // Assurez-vous que 'metrics' contient bien les données attendues
    if (!metrics) {
        return <div>Chargement des indicateurs clés...</div>;
    }

    return (
        <div className="key-metrics-section">
            {/* Les props 'metrics' devraient ressembler à { last90Days: '...', totalPaidTransactions: '...', ... } */}
            <MetricCard title="Indicateurs 90 derniers jours" value={metrics.last90Days} />
            <MetricCard title="Total des prestations versées" value={metrics.totalPaidTransactions} />
            <MetricCard title="Factures en attente de paiement" value={metrics.pendingInvoices} />
            <MetricCard title="Factures en retard" value={metrics.overdueInvoices} />
        </div>
    );
}

export default KeyMetricsSection;